import _ from 'lodash';
function ensure(m) {
    return m.default ? m.default : m;
}
export default ({ projectName, account, locale, useThirdParty = true }) => {
    setTimeout(() => {
        import('../../services/tracker/sentry').then(ensure).then(sentryApp => {
            sentryApp(projectName, account.thirdParty.sentry);
        });
        if (useThirdParty) {
            import('../../services/third-party').then(ensure).then(loadThirdParty => {
                loadThirdParty(locale);
            });
        }
        // @ts-ignore todo
        if (_.isObject(window.newrelic)) {
            // @ts-ignore todo
            window.newrelic.addPageAction('init', {
                uid: _.get(account, '_info.account_id', ''),
                cid: _.get(account, '_info.company_id', ''),
            });
        }
    }, 3 * 1000);
};
export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
